import axios from "axios";
import { formatDate } from "../utils/format";
import { URL } from "../constant/url";

const apiClient = axios.create({
  baseURL: `${URL}/api`,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "69420",
  },
});

const handleRequest = async (endpoint, fromDate, toDate) => {
  try {
    const response = await apiClient.post(endpoint, {
      data_key: process.env.REACT_APP_PRIVATE_KEY,
      // dataRanges: formatDate(dateRange),
      from_date: formatDate(fromDate),
      to_date: formatDate(toDate),
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching data from ${endpoint}:`,
      error.response?.data || error.message
    );
    // console.log("test", error.response.status);

    if (error.response.status === "403") {
      throw error;
    }

    throw new Error("Failed to fetch data. Please try again later.");
  }
};

export const fetchBudget = async (fromDate, toDate) =>
  handleRequest("/dashboard-report", fromDate, toDate);
